// Library Dependency
window.Library = class {
	
	static loading = {};
	static loaded = [];
	static defined = {
		dropzone: [
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/dropzone/5.9.3/dropzone.css" integrity="sha512-7uSoC3grlnRktCWoO4LjHMjotq8gf9XDFQerPuaph+cqR7JC9XKGdvN+UwZMC14aAaBDItdRj3DcSDs4kMWUgg==" crossorigin="anonymous" referrerpolicy="no-referrer" />`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/dropzone/5.9.3/dropzone.min.js" integrity="sha512-U2WE1ktpMTuRBPoCFDzomoIorbOyUv0sP8B+INA3EzNAhehbzED1rOJg6bCqPf/Tuposxb5ja/MAUnC8THSbLQ==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>`,
		],

		touchswipe: [
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery.touchswipe/1.6.19/jquery.touchSwipe.min.js"></script>`,
		],

		magnificPopup: [
			"touchswipe",
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/jquery.magnific-popup.min.js"></script>`,
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/magnific-popup.min.css" />`,
		],

		switchery: [
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/switchery/0.8.2/switchery.min.css" />`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/switchery/0.8.2/switchery.min.js"></script>`,
		],

		select2: [
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.13/css/select2.min.css" />`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.13/js/select2.min.js"></script>`,
		],

		datepicker: [
			"moment",
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/js/bootstrap-datepicker.min.js"></script>`,
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/css/bootstrap-datepicker.min.css" />`,
		],

		datetimepicker: [
			"moment",
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/tempusdominus-bootstrap-4/5.39.0/css/tempusdominus-bootstrap-4.min.css" crossorigin="anonymous" />`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/tempusdominus-bootstrap-4/5.39.0/js/tempusdominus-bootstrap-4.min.js" crossorigin="anonymous"></script>`,
		],

		daterangepicker: [
			"moment",
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-daterangepicker/3.0.5/daterangepicker.min.css" />`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-daterangepicker/3.0.5/daterangepicker.min.js"></script>`,
		],

		// "timedropper": [
		// 	"//cdnjs.cloudflare.com/ajax/libs/timedropper/1.0/timedropper.min.css",
		// 	"//cdnjs.cloudflare.com/ajax/libs/timedropper/1.0/timedropper.min.js"
		// ],

		datatable: [
			`<link rel="stylesheet" type="text/css" href="https://cdn.datatables.net/v/bs4/dt-1.11.5/datatables.min.css"/>`,
			`<script type="text/javascript" src="https://cdn.datatables.net/v/bs4/dt-1.11.5/datatables.min.js"></script>`,

			// `<link rel="stylesheet" href="//cdnjs.cloudflare.com/ajax/libs/datatables/1.10.21/css/dataTables.bootstrap4.min.css" />`,
			// `<script src="https://cdnjs.cloudflare.com/ajax/libs/datatables/1.10.21/js/jquery.dataTables.min.js"></script>`,
			// `<script src="https://cdnjs.cloudflare.com/ajax/libs/datatables/1.10.21/js/dataTables.bootstrap4.min.js"></script>`
		],

		"datatable-reorder": [
			"datatable",
			`<link rel="stylesheet" type="text/css" href="https://cdn.datatables.net/rowreorder/1.2.7/css/rowReorder.dataTables.min.css"/>`,
			`<script type="text/javascript" src="https://cdn.datatables.net/rowreorder/1.2.7/js/dataTables.rowReorder.min.js"></script>`,
		],

		alertify: [
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/alertifyjs-alertify.js/1.0.11/css/alertify.css" />`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/alertifyjs-alertify.js/1.0.11/js/alertify.js"></script>`,
		],

		intlTelInput: [
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/24.5.0/build/js/intlTelInputWithUtils.min.js"></script>`,
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/24.5.0/build/css/intlTelInput.min.css" />`,
		],


		moment: [
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.29.4/moment-with-locales.min.js" integrity="sha512-42PE0rd+wZ2hNXftlM78BSehIGzezNeQuzihiBCvUEB3CVxHvsShF86wBWwQORNxNINlBPuq7rG4WWhNiTVHFg==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/moment-timezone/0.5.43/moment-timezone-with-data.min.js" integrity="sha512-KCI+fR3bUbOcU0ZC3UcaPwCLuO5LEkukaWBYddmhLPXgpAPWJ8j6pJLmTI6t9CMYczE4YCrWZQ/wrZz/JsyC+A==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>`,
		],

		rsvp: [
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/rsvp/4.8.5/rsvp.min.js" integrity="sha512-HFmmKqGaLV2NYgTKWTLxKYsreelx/C5mZLO5kgcA00If59U0YbjAdOpVsoSAb6YTi5K11nVtotiQnSHkltN2XQ==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>`,
		],

		"frame-grab": [
			"rsvp",
			"<script src='https://gemidos.tv/static/libs/frame-grab/frame-grab.js'></script>",
		],

		scrollbooster: [
			"<script src='https://gemidos.tv/static/libs/scrollbooster/2.3.0/scrollbooster.js'></script>",
		],

		toastr: [
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/toastr.js/2.1.4/toastr.min.js"></script>`,
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/toastr.js/2.1.4/toastr.min.css" />`,
		],

		"font-roboto-condensed": [
			"//fonts.googleapis.com/css?family=Roboto+Condensed:300,400,700&display=swap",
		],

		"font-awesome": [
			// `<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.15.4/css/all.css">`,
			`<link rel="stylesheet" href="https://site-assets.fontawesome.com/releases/v6.2.0/css/all.css">`,
		],

		sortable: [
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/Sortable/1.15.0/Sortable.min.js" integrity="sha512-Eezs+g9Lq4TCCq0wae01s9PuNWzHYoCMkE97e2qdkYthpI0pzC3UGB03lgEHn2XM85hDOUF6qgqqszs+iXU4UA==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>`,
		],

		summernote: [
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/summernote/0.8.20/summernote.min.css" integrity="sha512-m52YCZLrqQpQ+k+84rmWjrrkXAUrpl3HK0IO4/naRwp58pyr7rf5PO1DbI2/aFYwyeIH/8teS9HbLxVyGqDv/A==" crossorigin="anonymous" referrerpolicy="no-referrer" />`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/summernote/0.8.20/summernote-bs4.min.js" integrity="sha512-ZESy0bnJYbtgTNGlAD+C2hIZCt4jKGF41T5jZnIXy4oP8CQqcrBGWyxNP16z70z/5Xy6TS/nUZ026WmvOcjNIQ==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>`,
		],

		jstree: [
			`<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/jstree-bootstrap-theme@1.0.1/dist/themes/proton/style.min.css">`,
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/jstree/3.3.15/themes/default/style.min.css" integrity="sha512-A5OJVuNqxRragmJeYTW19bnw9M2WyxoshScX/rGTgZYj5hRXuqwZ+1AVn2d6wYTZPzPXxDeAGlae0XwTQdXjQA==" crossorigin="anonymous" referrerpolicy="no-referrer" />`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/jstree/3.3.15/jstree.min.js" integrity="sha512-zTdDEt8tOqDRVRFKgypzg8g7FJE7A9lhnTZ6YpUlufaF/XvjIGF/zaPljDhER8XmIwePEAjBjv27TEuubED0/A==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>`,
		],

		selectpicker: [
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-select/1.13.18/css/bootstrap-select.min.css" />`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-select/1.13.18/js/bootstrap-select.min.js"></script>`,
		],

		pace: [
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/pace/1.2.4/themes/black/pace-theme-flash.min.css" integrity="sha512-2eEQTfqdt+0xvXCIn71dH/Ql5WzI+bVg50BnLJRwGPF2kRTA1Flgn6jLuggqN5may7GQgLvQYIlBmAz/HT6Arg==" crossorigin="anonymous" referrerpolicy="no-referrer" />`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/pace/1.2.4/pace.min.js" integrity="sha512-2cbsQGdowNDPcKuoBd2bCcsJky87Mv0LEtD/nunJUgk6MOYTgVMGihS/xCEghNf04DPhNiJ4DZw5BxDd1uyOdw==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>`,
		],

		labelauty: [
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/labelauty/1.1.4/jquery-labelauty.min.css" />`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/labelauty/1.1.4/jquery-labelauty.min.js"></script>`,
		],

		fabric: [
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/fabric.js/5.3.1/fabric.min.js" integrity="sha512-CeIsOAsgJnmevfCi2C7Zsyy6bQKi43utIjdA87Q0ZY84oDqnI0uwfM9+bKiIkI75lUeI00WG/+uJzOmuHlesMA==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>"></script>`,
		],

		jsCookie: [
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/js-cookie/2.2.1/js.cookie.min.js"></script>`,
		],

		qrcodejs: [
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js" integrity="sha512-CNgIRecGo7nphbeZ04Sc13ka07paqdeTu0WR1IM4kNcpmBAUSHSQX0FslNhTDadL4O5SAGapGt4FodqL8My0mA==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>`,
		],
		ace: [
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.12/ace.min.js"></script>`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.12/theme-nord_dark.min.js"></script>`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.12/theme-eclipse.min.js"></script>`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.12/theme-clouds_midnight.min.js"></script>`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.12/mode-css.min.js"></script>`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.12/mode-html.min.js"></script>`,
		],

		quill: [
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.min.js"></script>`,
			`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.snow.min.css"/>`,
		],

		segment: [
			`<script type="text/javascript" src="@@url_static/libs/jquery-segment/segment.js?@@md5"></script>`,
			`<link rel="stylesheet" href="@@url_static/libs/jquery-segment/segment.css?@@md5"/>`,
		],

		LayoutUi: [
			`<script src="@@url_static/script/layoutUi.js?@@md5"></script>`,
		],

		EmailComponent: [
			"OtpUi",
			`emailComponent.twig`,	// template
			`<script src="@@url_static/script/emailComponent.js?@@md5"></script>`,
		],

		RegisterComponent: [
			`<script src="@@url_static/script/registerComponent.js?@@md5"></script>`,
		],

		LoginComponent: [
			`<script src="@@url_static/script/loginComponent.js?@@md5"></script>`,
		],

		RecoveryComponent: [
			`<script src="@@url_static/script/recoveryComponent.js?@@md5"></script>`,
		],

		OtpUi: [
			`<script src="@@url_static/script/otpUi.js?@@md5"></script>`,
		],

		IdVerificationComponent: [
			`id-verification.twig`,	// template
			`<link rel="stylesheet" href="@@url_static/css/module/id-verification.css?@@md5"/>`,
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/human/3.0.5/human.js"></script>`,
			`<script src="@@url_static/script/idVerificationComponent.js?@@md5"></script>`,
		],

		WhatsAppComponent: [
			"intlTelInput", "OtpUi",
			"phrase:WHATSAPP_VERIFICATION",
			`whatsapp.twig`,
			`<link rel="stylesheet" href="@@url_static/css/module/id-verification.css?@@md5"/>`,
			`<script src="@@url_static/script/whatsAppComponent.js?@@md5"></script>`,
		],

		TelegramComponent: [
			"intlTelInput", "OtpUi",
			"phrase:TELEGRAM_VERIFICATION",
			`telegram.twig`,
			`<link rel="stylesheet" href="@@url_static/css/module/id-verification.css?@@md5"/>`,
			`<script src="@@url_static/script/telegramComponent.js?@@md5"></script>`,
		],

		TransactionComponent: [
			`<link rel="stylesheet" href="@@url_static/css/module/transaction.css?@@md5"/>`,
			`<script src="@@url_static/script/transactionComponent.js?@@md5"></script>`,
		],

		NotificationService: [
			`<script src="@@url_static/script/notificationService.js?@@md5"></script>`,
		],

		UploadGalleryComponent: [
			"frame-grab", "dropzone",
			'media-upload.twig',
			`<script src="@@url_static/script/uploadGalleryComponent.js?@@md5"></script>`,
		],

		UploadStoryComponent: [
			"frame-grab", "dropzone",
			// 'story-upload.twig', // el template contiene las ultimas historias, se debe cargar cada vez que se abre el modal
			`<script src="@@url_static/script/uploadStoryComponent.js?@@md5"></script>`,
		],

		PostComponent: [
			`<script src="@@url_static/script/postComponent.js?@@md5"></script>`,
		],

		XpComponent: [
			`<script src="@@url_static/script/xpComponent.js?@@md5"></script>`,
		],
	};

	static async load (request) {
		let self = this;
		var promises = [];

		// Recorrer cada request
		for (let library_name of Array.isArray(request) ? request : [request]) {
			// Generar promesa por cada una
			var promise = new Promise(async (resolve, reject) => {
				// marcar como cargada
				if (library_name.startsWith("<")) {
					self.defined[library_name] = [library_name];
				}

				// Esta definida ?
				if (self.defined[library_name] === undefined)
					return reject(`La libreria ${library_name} no esta definida`);

				// Esta siendo importada?
				if (library_name in self.loading) {
					// Espero que termione la promesa original
					await self.loading[library_name];
					return resolve();
				}

				// Ya fue importada ?
				if (self.loaded.includes(library_name)) return resolve();

				self.loaded.push(library_name);

				let _promises = [];

				for (let script of self.defined[library_name]) {
					let match;
					if (script.match(/<script/)) {
						_promises.push(self.js(script));
					} else if (script.match(/<link/)) {
						self.css(script);
					} else if ((match = script.match(/(.*)\.html$/))) {
						_promises.push(self.html(match[1]));
					} else if ((match = script.match(/(.*)\.twig$/))) {
						// checkear si ya esta cargado
						if(!document.getElementById(`${match[1]}.tpl`))
							_promises.push(self.twig(match[1]));
					} else if (script.startsWith("phrase:")) {
						const phrases = script.replace("phrase:", "").split(",");
						_promises.push(PhrasesService.load(phrases));
					} else {
						_promises.push(self.load(script));
					}

				}

				var tmp = Promise.all(_promises);

				self.loading[library_name] = tmp;

				if (_promises.length) await tmp;

				delete self.loading[library_name];

				return resolve();
			});

			promises.push(promise);
		}

		return await Promise.all(promises);
	}

	static html(template_name) {
		return new Promise(async (resolve, reject) => {
			try {
				var response = await (
					await fetch(`@@url_static/html/modal/${template_name}`)
				).text();

				// var script = document.createElement("script")
				// script.type = "text/html";
				// script.id = name;
				// document.getElementById("jsEntry").before(script);
				// script.innerHTML = await CodingAR.Network.get({url: url, dataType: 'html'});
				resolve();
			} catch (error) {
				error.source = source;
				reject(error);
			}
		}).catch(async (error) => {
			error.source = 'NowLibrary';
			error.context = {
				type: 'html',
				template: template_name,
			};
			throw error;
		});
	}

	static async retryWithDelay(fn, initialDelay, maxRetries = 3) {
		let attempts = 0;
		let delay = initialDelay;

		while (attempts < maxRetries) {
			try {
				return await fn();
			} catch (error) {
				attempts++;

				if (attempts >= maxRetries) {
					throw error;
				}

				// Espera el delay actual y luego incrementa
				await new Promise(resolve => setTimeout(resolve, delay));
				delay *= 2; // Aumenta el delay exponencialmente
			}
		}
	}

	static async twig(template_name) {
		return this.retryWithDelay(async () => {
			const response = await (await fetch(`/api/template/${template_name}`, {
				method: "POST",
			})).text();

			if (response.trim().startsWith("<script")) {
				document.querySelector("body").insertAdjacentHTML("beforeend", response);
			} else {
				document.querySelector("body").insertAdjacentHTML(
					"beforeend",
					`<script id="${template_name}.tpl" type="text/html">${response}</script>`
				);
			}
		}, 3000, 5) // Reintenta 3 veces con un delay inicial de 3 segundos
			.catch(async (error) => {
				error.source = 'NowLibrary';
				error.context = {
					type: 'twig',
					template: template_name,
				};
				throw error;
			});
	}

	static async js (file) {

		return this.retryWithDelay(async () => {

			return new Promise((resolve, reject) => {
				var tmp = $(file);

				var script = document.createElement("script");
				// script.type = "text/javascript";
				script.async = false; // IMPORTANTE. Por default son ASYNC y ejecutan en cualquier orden.
				script.crossOrigin = "anonymous";
				script.defer = true;
				if(tmp[0].integrity)
					script.integrity = tmp[0].integrity;

				script.onload = function () {
					resolve();
				};

				script.onerror = function (event) {
					const error = new Error(`Error al cargar el script: ${script.src}`);
					error.source = 'NowLibrary';
					error.context = {
						type: 'js',
						file: file,
						message: event?.message || 'No se puede cargar el script',
						status: event?.target?.status || 'Desconocido', // en caso de que haya más información del evento
						cors: script.crossOrigin,
					};
					reject(error);
				};

				script.src = tmp[0].src;

				document.getElementById("jsentry").before(script);
			}).catch(async (error) => {
				error.source = 'NowLibrary';
				error.context = {
					type: 'js',
					file: file,
				};
				throw error;
			});

		}, 3000, 5); // Reintenta cada 3 segundos si hay un error
	}

	static css(file) {
		var file = $(file);
		var link = document.createElement("link");
		link.rel = "stylesheet";
		link.href = file[0].href;
		link.integrity = file[0].integrity;
		link.crossOrigin = "anonymous";
		document.getElementById("cssentry").before(link);
	}

	static add(key, url, type = null) {
		const self = this;

		if (self.defined[key] == undefined) {
			self.defined[key] = [];
		}
		if (type == "script") {
			self.defined[key].push(`<script src="${url}"></script>`);
		} else if (type == "style") {
			self.defined[key].push(
				`<link rel="stylesheet" href="${url}" />`
			);
		} else {
			self.defined[key].push(url);
		}
	}

	static addInlineDefines() {
		const self = this;
		const dataAttributes = $('#page-library').data();
		for (let key in dataAttributes) {
			if (dataAttributes.hasOwnProperty(key)) {
				let value = dataAttributes[key];
				self.add(key, value.url, value.type);
			}
		}
	}
};